<template lang="pug">
  .villa-blanca
    .villa-blanca__main(v-if="isAllowed")
      Home
      ArtOfLiving
      Collection(
        v-for="(collection, index) in collections", 
        :id="collection.slug"
        :key="collection.slug",
        v-if="collection.isActive", 
        :collection="collection",
        @open-popup="openPopupBySlugAndId"
      )
      .popup(v-if="showPopup", :class="{'popup--animate' : showPopup }", id="popup", ref="popup")
        swiper.popup__swiper(
          :options="swiperOption", 
          ref="mySwiper",
          @slideChange="changeProductAndColor"
        )
          swiper-slide.popup__product(
            v-for="(item, index) in currentCollectionItems",
            :key="item.slug",
            :id="item.slug+'_popup'"
          )
            FullItem(:item="item", :isPopupOpen="showPopup")
        .swiper-button-next
        .swiper-button-prev
        .container.popup__panel-container
          .row
            .col-xs-12
              .popup__panel(:style="{ 'backgroundColor' : activeProductColor, 'boxShadow' : `0px 0px 70px ${activeProductColor}`}")
        .popup__close-button(@click="closePopup") +
        .popup__overlay
      TasteSecret
      LifeStyle
      Features
      Feedback
      Footer
    Intro(@allow-access="allowAccess" v-if="!isAllowed")
</template>

<script>
import Cookies from "js-cookie";

import Home from "./components/Home.vue";
import ArtOfLiving from "./components/ArtOfLiving.vue";
import Collection from "./components/Collection.vue";
import FullItem from "./components/FullItem.vue";
import TasteSecret from "./components/TasteSecret.vue";
import LifeStyle from "./components/LifeStyle.vue";
import Features from "./components/Features.vue";
import Feedback from "./components/Feedback.vue";
import Footer from "./components/Footer.vue";
import Intro from "./components/Intro.vue";

export default {
  name: "app",
  components: {
    Home,
    Collection,
    ArtOfLiving,
    FullItem,
    LifeStyle,
    Features,
    Feedback,
    Footer,
    TasteSecret,
    Intro
  },
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        initialSlide: 0,
        speed: 900
      },
      collections: [
        {
          slug: "fizzy",
          description:
            "Изысканные напитки Villa Blanca созданы исключительно для того, чтобы вы могли наслаждаться вкусом жизни, могли почувствовать все оттенки и полутона этого бесконечно красивого и совершенного мира.",
          background: "#f9b000",
          isActive: true,
          items: [
            {
              title: "Moscato",
              subtitle: "Разве уже вечер?! А разве нет?",
              description:
                "Не надо ничего придумывать, просто дождитесь, когда солнце будет клониться к закату, найдите свободный столик, выберете тему для разговора и смешайте слова с изысканным мускатным вкусом Villa Blanca Moscato. Мы знаем, когда закончится одна тема, вы перейдете к следующей, но помните, сразу остановиться не получится, да мы и не настаиваем.",
              taste: "Мускат, миндаль",
              food: "Сыры, фрукты, десерты",
              temperature: "До 6-7 градусов",
              instruction: "когда вечер утра мудренее",
              strength: "7,5%",
              color: "#EE7622",
              colorGradient: "#FFF0DB",
              colorShadow: "#FF6900",
              isHighlighted: true,
              isSmall: false,
              image: "moscato.png",
              fullImage: "moscato-xxl.png",
              slug: "moscato",
              parallaxDepth: "0.03",
              fadeDelay: "1/3"
            },
            {
              title: "Bianco",
              subtitle: "Ох, еще так рано!",
              description:
                "Утро нового дня, как хорошая музыка исполняется точно по нотам. Попросите кого-нибудь достать из холодильника новую, гармонично купажированную партитуру Villa Blanca Bianco и сыграйте в до мажоре ноты белых цветов, время от времени меняя тональность в диапазоне от мяты до лайма.",
              taste: "Цветы, черная смородина, мята, лайм",
              food: "Птица, рыба, салат",
              temperature: "До 6-7 градусов",
              instruction: "рано утром и не в одиночестве",
              strength: "7,5%",
              color: "#C9A200",
              colorGradient: "#F6F3D5",
              colorShadow: "#C19B00",
              isHighlighted: true,
              isSmall: false,
              image: "bianco.png",
              fullImage: "bianco-xxl.png",
              slug: "bianco",
              parallaxDepth: "-0.03",
              fadeDelay: "3/3"
            },
            {
              title: "Rose",
              subtitle: "Ах, оставьте!",
              description:
                "Собраться хорошей компанией – это начало, позвонить кому-нибудь еще – продолжение, устроить гламурный débauche – пик веселья. Вот только без Villa Blanca Rose, без его экстравагантного грейпфрута, аромата полевых цветов и белых фруктов – это точно не получится.",
              taste: "Белые фрукты, грейпфрут, мята, цветы",
              food: "Белое мясо, морепродукты, салаты",
              temperature: "До 6-7 градусов",
              instruction: "не задумываясь",
              strength: "7,5%",
              color: "#E4032C",
              colorGradient: "#FBE3EB",
              colorShadow: "#DD0129",
              isHighlighted: true,
              isSmall: false,
              image: "rose.png",
              fullImage: "rose-xxl.png",
              slug: "rose",
              parallaxDepth: "0.02",
              fadeDelay: "2/3"
            },
            {
              title: "Mojito",
              subtitle: "Эта жара сведет меня с ума!",
              description:
                "Когда на небе нет ни одного облачка и каблуки вязнут в асфальте, когда солнце вышло за пределы своей компетентности и припекает так, что лед тает в бокале быстрее, чем успевает замораживаться, когда ветер дезертировал еще утром, а зонтик от солнца превратился в грустную насмешку, единственное, что может спасти ситуацию - это мятно-цитрусовый Villa Blanca Mojito.",
              taste: "Цитрусы, мята",
              food: "Аперитив, тропические фрукты",
              temperature: "До 6-7 градусов",
              instruction: "глядя на голубое небо",
              strength: "7,5%",
              color: "#007938",
              colorGradient: "#C5F5F6",
              colorShadow: "#006F34",
              isHighlighted: true,
              isSmall: false,
              image: "mojito.png",
              fullImage: "mojito-xxl.png",
              slug: "mojito",
              parallaxDepth: "-0.03",
              fadeDelay: "2/2"
            },
            {
              title: "Violetto",
              subtitle: "Ой, всё!",
              description:
                "Не всем нужно, но все хотят. Если вы решили собраться с друзьями не ради праздности и веселья, а ради того, чтобы принести себя в жертву богу еды, скрестить, так сказать, столовые приборы над стейком или фалафелем, то вам непременно нужно прихватить с собой Villa Blanca Violeto. Элегантный вкус красного винограда с тонкими нотами спелых фруктов превратит обычный ужин в гастрономический гала-концерт.",
              taste: "Красный виноград, фрукты",
              food: "Красное мясо, блюда из овощей, пицца",
              temperature: "До 6-7 градусов",
              instruction: "от заката до рассвета",
              strength: "7,5%",
              color: "#E4032C",
              colorGradient: "#FBD3FF",
              colorShadow: "#E4032C",
              isHighlighted: true,
              isSmall: false,
              image: "violetto.png",
              fullImage: "violetto-xxl.png",
              slug: "violetto",
              parallaxDepth: "0",
              fadeDelay: "1/2"
            }
          ]
        },
        {
          title: "Напитки винные Fruitifull",
          description:
            "Фруктовые винные напитки Villa Blanca Fruitifull идеальны к десертам, фруктам, как аперитив, а также отличное сопровождение мясных блюд с ягодными соусами. ",
          background: "#f58d2d",
          slug: "fruit",
          isActive: false,
          items: [
            {
              title: "Strawberry Raspberry",
              subtitle: "",
              description: "",
              taste: "клубника малина",
              food: "",
              temperature: "",
              instruction: "",
              strength: "",
              color: "#FFCDCD",
              colorGradient: "#FF5353",
              colorShadow: "#F38646",
              image: "strawberry-raspberry.png",
              fullImage: "strawberry-raspberry-xxl.png",
              isHighlighted: false,
              isSmall: true,
              slug: "strawberry-raspberry",
              parallaxDepth: "-0.001",
              fadeDelay: "1/4"
            },
            {
              title: "Passionfruit Grapefruit",
              subtitle: "",
              description: "",
              taste: "маракуйя грейпфрут",
              food: "",
              temperature: "",
              instruction: "",
              strength: "",
              color: "#F69512",
              colorGradient: "#EF6AA7",
              colorShadow: "#F38646",
              image: "passionfruit-grapefruit.png",
              fullImage: "passionfruit-grapefruit-xxl.png",
              isHighlighted: false,
              isSmall: true,
              slug: "passionfruit-grapefruit",
              parallaxDepth: "0.005",
              fadeDelay: "2/4"
            },
            {
              title: "Passionfruit Pineapple",
              subtitle: "",
              description: "",
              taste: "маракуйя ананас",
              food: "",
              temperature: "",
              instruction: "",
              strength: "",
              color: "#FEFFCE",
              colorGradient: "#FF9A00",
              colorShadow: "#F38646",
              image: "passionfruit-pineapple.png",
              fullImage: "passionfruit-pineapple-xxl.png",
              isHighlighted: false,
              isSmall: true,
              slug: "passionfruit-pineapple",
              parallaxDepth: "-0.015",
              fadeDelay: "3/4"
            },
            {
              title: "Pomegranat Grapefruit",
              subtitle: "",
              description: "",
              taste: "гранат грейпфрут",
              food: "",
              temperature: "",
              instruction: "",
              strength: "",
              color: "#FFDEEF",
              colorGradient: "#FD7733",
              colorShadow: "#F38646",
              image: "pomegranat-grapefruit.png",
              fullImage: "pomegranat-grapefruit-xxl.png",
              isHighlighted: false,
              isSmall: true,
              slug: "pomegranat-grapefruit",
              parallaxDepth: "0.005",
              fadeDelay: "4/4"
            }
          ]
        },
        {
          title: "Сангрия",
          description:
            "Сладкие винные напитки Sangria Villa Blanca легкие и прохладительные. В жаркий день на отдыхе или на знойной вечеринке с друзьями они станут прекрасной летней альтернативой классическим белым и красным винам.",
          background: "#d7624f",
          slug: "sangria",
          isActive: true,
          items: [
            {
              title: "Sangria Bianco",
              subtitle: "Это уже слишком!",
              description:
                "Когда вы слышите фразу «ни к чему не обязывает», то речь, скорее всего, идет о Sangria Bianco. Но осторожность не помешает. Слишком все легко, слишком все просто, слишком прозрачно, слишком все слишком, прямо без обязательств. Да, чьёрт побери! Так и есть. Это же сангрия Bianco! Доверьтесь её фруктовой, освежающей карусели, на которой прохлаждаются ароматные цитрусы. Запрыгивайте!",
              taste: "Фрукты, цитрусы",
              food: "Рыба, морепродукты, десерты",
              temperature: "До 6-7 градусов",
              instruction: "когда хочется",
              strength: "8%",
              color: "#FFEDD3",
              colorGradient: "#FFCC83",
              colorShadow: "#F28566",
              image: "sangria-bianco.png",
              fullImage: "sangria-bianco-xxl.png",
              isHighlighted: false,
              isSmall: false,
              slug: "sangria-bianco",
              parallaxDepth: "0",
              fadeDelay: "1/2"
            },
            {
              title: "Sangria Tinto",
              subtitle: "Вы приглашены!",
              description:
                "Оставьте классику снобам. Здесь нет места напыщенным полутонам и выдержанным, то есть очень одиноким вкусам. Это Сангрия! Это карнавал вкуса и безудержного веселья в вашем бокале! Хотите стать королем пати?! У вас должна быть фруктово-ягодная Sangria Tinto! Без вариантов.",
              taste: "Фрукты, ягоды, апельсин",
              food: "Красное мясо, сыры, фруктовые десерты",
              temperature: "До 6-7 градусов",
              instruction: "весь вечер и всю ночь",
              strength: "8%",
              color: "#FFD5DC",
              colorGradient: "#CD5266",
              colorShadow: "#AB0819",
              image: "sangria-tinto.png",
              fullImage: "sangria-tinto-xxl.png",
              isHighlighted: false,
              isSmall: false,
              slug: "sangria-tinto",
              parallaxDepth: "-0.015",
              fadeDelay: "2/2"
            }
          ]
        },
        {
          title: "Вермуты",
          description:
            "Вермуты Villa Blanca отличаются приятным горьковатым вкусом и тонким ароматом пряностей. Вермут можно отнести к категории all day drink. С ним легко растягивать удовольствие, неспешно наслаждаясь изысканным вкусом и удивительным ароматом.",
          background: "#db3566",
          slug: "vermouth",
          isActive: true,
          items: [
            {
              title: "Vermouth Bianco",
              subtitle: "А чем всё закончилось?",
              description:
                "Вам же нравятся шикарные истории с горьким привкусом в середине и ванильной развязкой в конце? Признайтесь, ведь нравятся? Нам тоже. Поэтому Vermouth Bianco как хорошо срежиссированный сериал, можно потреблять весь день и ждать с нетерпением продолжения на следующей неделе. Не уходите. Рекламы не будет.",
              taste: "Горные травы, ваниль, сладость",
              food: "Аперитив, оливки, твердые сыры, морепродукты, фрукты",
              temperature: "До 6-7 градусов",
              instruction: "с главными героями днем",
              strength: "10%",
              color: "#FFEDD3",
              colorGradient: "#EED08B",
              colorShadow: "#F3B737",
              image: "vermouth-bianco.png",
              fullImage: "vermouth-bianco-xxl.png",
              isHighlighted: false,
              isSmall: false,
              slug: "vermouth-bianco",
              parallaxDepth: "0",
              fadeDelay: "1/2"
            },
            {
              title: "Vermouth Rosso",
              subtitle: "Я летаю, я в раю…",
              description:
                "Самый красный из всех горьких. Звучит неоднозначно, зато кружит голову и меняет настроение, от которого другие сходят с ума, не будем уточнять кто. Жженного сахара здесь нет, не дождетесь, только сладкая карамель, ягоды и высокогорные травы, такие высокие и такие горные, что просто дух захватывает. Не улетайте под облака, на земле тоже хорошо, к тому же Vermouth Rosso всегда под рукой.",
              taste: "Горные травы, ягоды, карамель",
              food: "Аперитив, холодные мясные закуски, крекеры, сыры, фрукты",
              temperature: "До 6-7 градусов",
              instruction: "сидя на облаке",
              strength: "8%",
              color: "#FFB4B0",
              colorGradient: "#FF7D75",
              colorShadow: "#951617",
              image: "vermouth-rosso.png",
              fullImage: "vermouth-rosso-xxl.png",
              isHighlighted: false,
              isSmall: false,
              slug: "vermouth-rosso",
              parallaxDepth: "-0.010",
              fadeDelay: "2/2"
            }
          ]
        }
      ],
      showPopup: false,
      activeProductCollection: "fizzy",
      activeProductColor: "green",
      activeProductId: 0,
      isAllowed: false
    };
  },
  computed: {
    currentCollectionItems() {
      return this.collections.find(
        collection => collection.slug === this.activeProductCollection
      ).items;
    }
  },
  methods: {
    openPopupBySlugAndId({ slug, index }) {
      this.showPopup = true;
      this.activeProductCollection = slug;
      this.swiperOption.initialSlide = index;
      this.activeProductId = index;

      var activeCollection = this.collections.find(
        collection => collection.slug === this.activeProductCollection
      );
      this.changeActiveColor(activeCollection.items[index]);

      document.documentElement.classList.add("no-scroll");
    },
    closePopup() {
      this.$refs.popup.style.opacity = "0";

      setTimeout(() => {
        this.showPopup = false;
        document.documentElement.classList.remove("no-scroll");
      }, 300);
    },
    changeProductAndColor() {
      var swiper = this.$refs.mySwiper.swiper;
      this.activeProductId = swiper.activeIndex;

      var activeCollection = this.collections.find(
        collection => collection.slug === this.activeProductCollection
      );

      this.changeActiveColor(activeCollection.items[swiper.activeIndex]);
    },
    changeActiveColor(item) {
      if (!item.colorGradient || item.isHighlighted) {
        this.activeProductColor = item.color;
      } else {
        this.activeProductColor = item.colorGradient;
      }
    },
    allowAccess() {
      this.isAllowed = !this.isAllowed;
      Cookies.set("allow", "true", { expires: 7 });
    }
  },
  mounted() {
    var cookie = Cookies.get("allow");
    if (cookie === "true") {
      this.isAllowed = true;
    }
  }
};
</script>

<style lang="scss">
@import "./styles/main.scss";

html {
  &.no-scroll {
    position: absolute;
    width: 100%;
    overflow-y: hidden;
  }
}

html,
body {
  max-width: 100%;
  overflow-x: hidden;
  font-family: $font-carlito;
}

*:focus {
  outline-color: $color-primary;
}

#app {
  font-family: "Carlito", sans-serif;
}

.container {
  @include from("xl") {
    width: 1259px;
  }
  @include from("xxxl") {
    width: 70%;
  }
}

.popup {
  position: relative;
  z-index: 2000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: auto;
  overflow-y: scroll;
  transition: 0.9s ease-in-out;

  @include from("lg") {
    overflow-y: hidden;
  }

  &__panel-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  &__panel {
    width: 100%;
    height: 96vh;
    margin-top: 4vh;
    margin-bottom: 0;
    z-index: 1;
    transform-origin: center left;
    position: relative;
    box-sizing: border-box;
    transition: 0.5s ease-in-out;
    background-image: linear-gradient(356deg, #fff0db 6%, #fff0db00 98%);

    @include from("lg") {
      margin-top: 9%;
      margin-bottom: 13%;
      height: 78vh;
    }

    @include from("xxl") {
      margin-top: 13%;
      margin-bottom: 12%;
      height: 75vh;
    }
  }
  &__close-button {
    position: fixed;
    color: $color-text--contrast;
    font-size: 40px;
    line-height: 40px;
    transform: rotate(45deg);
    z-index: 100;
    cursor: pointer;
    padding: 15px;

    top: 5%;
    right: 5%;

    @include from("xxxl") {
      font-size: 93px;
      line-height: 0.5;
      padding: 25px;
    }
  }
  &__overlay {
    background: #000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.85;
    z-index: -1;
  }
  &__swiper {
    z-index: 2;

    @include from("xl") {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      height: 100%;
      width: 100%;
    }
  }
  .swiper-button-next,
  .swiper-button-prev {
    width: 23px;
    height: 57px;
    opacity: 0.7;
    position: fixed;

    &:hover {
      opacity: 1;
    }

    @include from("lg") {
      position: absolute;
    }
  }
  .swiper-button-next {
    background-image: url("./assets/slider-next.svg");
  }
  .swiper-button-prev {
    background-image: url("./assets/slider-prev.svg");
  }

  @include from("lg") {
    &--animate {
      .popup__panel {
        transform: scale(0.8, 0);
        animation: popupPanelAnimation 0.7s 0.35s
          cubic-bezier(0.02, 0.29, 0.91, 1.01) forwards;
      }
      .popup__close-button {
        opacity: 0;
        transform: rotate(45deg) skew(-30deg, -30deg);
        animation: popupCloseButtonAnimation 0.3s 0.5s
          cubic-bezier(0.49, 0.07, 0.41, 1.12) forwards;
      }
      .popup__overlay {
        opacity: 0;
        animation: popupOverlayAnimation 0.5s 0.6s ease-in-out forwards;
      }

      .product {
        &__subtitle {
          opacity: 0;
          animation: popupTextAnimation 0.5s 0.6s cubic-bezier(0, 0.01, 0, 1)
            forwards;
        }
        &__description {
          opacity: 0;
          animation: popupTextAnimation 0.5s 0.7s cubic-bezier(0, 0.01, 0, 1)
            forwards;
        }
        &__specifications {
          opacity: 0;
          animation: popupTextAnimation 0.5s 0.8s cubic-bezier(0, 0.01, 0, 1)
            forwards;
        }
      }
    }
  }
}
</style>
